import React from "react";

const SvgPlus = props => (
  <svg id={props.id} width={26} height={26} {...props}>
    <defs>
      <path
        id={`plus_svg__a-${props.id}`}
        d="M12.44 1.815c.207-.208.31-.459.31-.752 0-.294-.103-.545-.31-.753a1.025 1.025 0 00-.753-.31c-.293 0-.544.103-.752.31l-4.56 4.56L1.815.31A1.025 1.025 0 001.063 0C.769 0 .518.103.31.31.103.518 0 .769 0 1.063c0 .293.103.544.31.752l4.56 4.56-4.56 4.56c-.207.208-.31.459-.31.752 0 .294.103.545.31.753.208.207.459.31.753.31.293 0 .544-.103.752-.31l4.56-4.56 4.56 4.56c.208.207.459.31.752.31.294 0 .545-.103.753-.31.207-.208.31-.459.31-.753 0-.293-.103-.544-.31-.752l-4.56-4.56 4.56-4.56z"
      />
    </defs>
    <g
      fill="none"
      fillRule="evenodd"
      transform="rotate(45 -3.274 29.67) translate(-10,0)"
    >
      <mask id={`plus_svg__b-${props.id}`} fill="#fff">
        <use xlinkHref={`#plus_svg__a-${props.id}`} />
      </mask>
      <use
        fill="#3E3E3E"
        fillRule="nonzero"
        xlinkHref={`#plus_svg__a-${props.id}`}
      />
      <g fill="#3E3E3E" mask={`url(#plus_svg__b-${props.id})`}>
        <path d="M-1.594-1.594h15.938v15.938H-1.594z" />
      </g>
    </g>
  </svg>
);

export default SvgPlus;
